import React, { FC, useEffect } from 'react';

import { useHistory } from 'react-router-dom';

import { Loader } from '../../components/Loader';
import { useAuth } from '../../utils/hooks';

const RegistrationPage: FC = () => {
  const history = useHistory();
  const { loginWithRedirect, isAuthenticated, isLoading, isInitialized } = useAuth();

  useEffect(() => {
    if (isInitialized && !isLoading) {
      if (isAuthenticated) {
        history.replace('/home');
      } else {
        loginWithRedirect({
          redirectUri: `/pricing`,
          mode: 'signUp',
        });
      }
    }
  }, [isInitialized, isLoading, isAuthenticated, loginWithRedirect, history]);

  return <Loader />;
};

export default RegistrationPage;
